import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface CircumstancesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<CircumstancesServiceData>(
    db,
    'circumstancesService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
